import { Navigate, useLocation } from 'react-router-dom';
import { useStore } from '../context/StoreContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useStore();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bgDark">
        <div className="text-neonBlue text-xl">Cargando...</div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" state={{ from: location.pathname }} />;
};

export default ProtectedRoute;